/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Country from "../../components/Country";

const AdminCountry = (props) => {
    return (
        <Country moduleType={'Admin'}  {...props}/>
    )
}

export default AdminCountry